import { useEffect } from 'react'

import { useAuth } from 'core/auth'

export const useWalletListener = () => {
    const {
        methods: { removeUserInfo }
    } = useAuth()

    useEffect(() => {
        const { ethereum } = window
        ethereum?.on?.('accountsChanged', removeUserInfo)

        return () => ethereum?.removeListener?.('accountsChanged', removeUserInfo)
    }, [removeUserInfo])

    useEffect(() => {
        const { solana } = window

        solana?.on?.('accountChanged', removeUserInfo)
        return () => solana?.removeListener?.('accountChanged', removeUserInfo)
    })
}
